import api from "../core/http";

/**
 * In-app support chat (reader side).
 */

/**
 * Send a support message. Guests must pass an email; signed-in readers are
 * answered on their account email and their messages join their open thread.
 */
export const sendSupportMessage = ({
  message,
  email = null,
  pageUrl = null,
}) => {
  return api
    .post(`/v1/support/messages`, {
      message,
      ...(email ? { email } : {}),
      ...(pageUrl ? { pageUrl } : {}),
    })
    .then((res) => res.data);
};

/**
 * The signed-in reader's latest conversation, or { data: null }.
 */
export const getMySupportConversation = () => {
  return api.get(`/v1/support/conversation`).then((res) => res.data);
};

/**
 * Clear the "new reply" dot once the reader has opened the chat.
 */
export const markSupportConversationRead = () => {
  return api.post(`/v1/support/conversation/read`).then((res) => res.data);
};
